import { DefaultFastestImageDomain } from 'store/data/Base'
import { FASTEST_IMAGE_DOMAIN_KEY } from 'util/Common'
import { isBrowserEnv } from '@app/utils/constants'
import { getFastestImgDomainFormCache } from '@saas2/utils'

export default function useFastestImageDomain(
    url: string
) {
    const pathname = (url || '').replace(`https://${DefaultFastestImageDomain}`, '')
    const fastestImageDomain = isBrowserEnv ? getFastestImgDomainFormCache() || DefaultFastestImageDomain : DefaultFastestImageDomain
    const src = `https://${fastestImageDomain}${pathname}`

    return {
        src,
        fastestImageDomain
    }
}
